import {pathHelpContentFile} from '../../../utils/path';
import {CONTENT_TYPE_TEXT, CONTENT_TYPE_IMAGE, CONTENT_CATEGORY_DOCUMENT} from '../../constants';

export default {
  id: 'STATUS_DOC',
  title: 'A quoi correspond le statut d’un document ?',
  description: '',
  categories: [CONTENT_CATEGORY_DOCUMENT],
  contents: [{
    type: CONTENT_TYPE_TEXT,
    value: 'Chaque intitulé de document est suivi d’un pictogramme qui vous permettra de connaitre son état :'
  },
  {
    type: CONTENT_TYPE_TEXT,
    value: 'Manquant : le document n’a jamais été déposé'
  },
  {
    type: CONTENT_TYPE_IMAGE,
    value: `${pathHelpContentFile}fr/FR_STATUT_DOC/FR_STATUT_DOC_1.png`
  },
  {
    type: CONTENT_TYPE_TEXT,
    value: 'En attente de signature : le document doit être signé par le signataire du compte'
  },
  {
    type: CONTENT_TYPE_IMAGE,
    value: `${pathHelpContentFile}fr/FR_STATUT_DOC/FR_STATUT_DOC_2.png`
  },
  {
    type: CONTENT_TYPE_TEXT,
    value: 'Refusé : le document a été refusé, pensez à consulter la raison du refus'
  },
  {
    type: CONTENT_TYPE_IMAGE,
    value: `${pathHelpContentFile}fr/FR_STATUT_DOC/FR_STATUT_DOC_3.png`
  },
  {
    type: CONTENT_TYPE_TEXT,
    value: 'Expiré : le document à une date de fin de validité dépassée'
  },
  {
    type: CONTENT_TYPE_IMAGE,
    value: `${pathHelpContentFile}fr/FR_STATUT_DOC/FR_STATUT_DOC_7.png`
  },
  {
    type: CONTENT_TYPE_TEXT,
    value: 'En attente de collecte : le document est en cours de collecte par nos services'
  },
  {
    type: CONTENT_TYPE_IMAGE,
    value: `${pathHelpContentFile}fr/FR_STATUT_DOC/FR_STATUT_DOC_4.png`
  },
  {
    type: CONTENT_TYPE_TEXT,
    value: 'En attente de vérification : tous documents déposés sont vérifiés et authentifiés par les services d’Attestation Légale'
  },
  {
    type: CONTENT_TYPE_IMAGE,
    value: `${pathHelpContentFile}fr/FR_STATUT_DOC/FR_STATUT_DOC_5.png`
  },
  {
    type: CONTENT_TYPE_TEXT,
    value: 'Valide : Le document est disponible pour vos clients'
  },
  {
    type: CONTENT_TYPE_IMAGE,
    value: `${pathHelpContentFile}fr/FR_STATUT_DOC/FR_STATUT_DOC_6.png`
  }]
};
